import React from 'react';
import { X } from 'lucide-react';

const MeetingInfoDialog = ({ isOpen, onClose, roomCode }) => {
  if (!isOpen) return null;
  
  return (
    <div className="absolute top-16 left-4 bg-gray-800 rounded-lg shadow-lg p-4 w-80">
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-medium">Meeting details</h3>
        <button onClick={onClose} className="text-gray-400 hover:text-white">
          <X size={18} />
        </button>
      </div>
      <div className="mb-3">
        <div className="text-sm text-gray-400 mb-1">Joining info</div>
        <div className="flex items-center justify-between">
          <span className="font-mono">{roomCode}</span>
          <button 
            className="text-blue-400 text-sm"
            onClick={() => {
              navigator.clipboard.writeText(roomCode);
              alert('Meeting code copied to clipboard');
            }}
          >
            Copy
          </button>
        </div>
      </div>
      <div>
        <button className="w-full py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-sm">
          Add others
        </button>
      </div>
    </div>
  );
};

export default MeetingInfoDialog; 